// /* eslint-disable */
import React, { useState, useEffect } from "react";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import "../../_components/antd.css";
import { Table } from "antd";
import "../../assets/css/AddedCss.css";
import alertify from "alertifyjs";
import UserDetailEdit from "./UserEdit";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
// import { Master } from "../Master/user";
import { AddMasterServer } from "../../services/apiUtils";
import ApiService from "../../services/httpService";

/**
 * AllMasterDetails is a React component that manages the display and manipulation
 * of user and master data within a table format. It provides functionalities
 * such as searching, filtering, and exporting user data, as well as linking
 * users with master records. The component fetches user and master data
 * from an API, handles state management for UI elements like modals and
 * tables, and provides user interaction capabilities for viewing and editing
 * user details.
 */

const AllMasterDetails = () => {
  const [menu, setMenu] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [UserList, setUserList] = useState([]);
  const [hideContent, setHideContent] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [EditModal, setEditModal] = useState(false);
  const [editTemple, setEditTemple] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [user, setUser] = useState([]);
  const [loading, setLoading] = useState(false);
  const [Masterloading, setMasterLoading] = useState(false);
  const [error, setError] = useState(false);
  const [FetchMaster, setFetchMaster] = useState();
  const [search, setSearch] = useState("");
  const [selectedMasters, setSelectedMasters] = useState([]);
  const [UserIdReload, setUserIdReload] = useState();
  const [UserMasters, setUserMasters] = useState([]);

  // history
  const history = useHistory();
  /**
   * Toggles the mobile menu visibility and positions the notification
   * message at the top-right corner of the page using alertify.
   */
  const toggleMobileMenu = () => {
    setMenu(!menu);
    topRight();
  };

  const fetchUser = async () => {
    try {
      const response = await ApiService.getPublic(`api/CenPilot/UserList`);

      if (response === "Invalid Device ID.") {
        alert("Invalid Device ID. Please log in again.");
        localStorage.clear();
        history.push("/login");
        return;
      }

      console.log("data for User", response);
      setUser(response);
      setError("");
    } catch (err) {
      console.error("Error fetching members:", err);

      if (
        err?.response?.data === "Invalid Device ID." ||
        err?.message?.includes("Invalid Device ID")
      ) {
        alert("Invalid Device ID. Please log in again.");
        localStorage.clear();
        history.push("/login");
        return;
      }

      setError("Failed to fetch User...");
      alertify.error("Failed to fetch User...");
    } finally {
      setLoading(false);
    }
  };

  const fetchMaster = async () => {
    setMasterLoading(true);
    try {
      const response = await ApiService.getPublic(`api/CenPilot/MasterList`);

      if (response === "Invalid Device ID.") {
        alert("Invalid Device ID. Please log in again.");
        localStorage.clear();
        history.push("/login");
        return;
      }

      console.log("data for Master", response);
      setFetchMaster(response);
      setError("");
    } catch (err) {
      console.error("Error fetching Master:", err);

      if (
        err?.response?.data === "Invalid Device ID." ||
        err?.message?.includes("Invalid Device ID")
      ) {
        alert("Invalid Device ID. Please log in again.");
        localStorage.clear();
        history.push("/login");
        return;
      }

      setError("Failed to fetch Master");
      alertify.error("Failed to fetch Master...");
    } finally {
      setMasterLoading(false);
    }
  };

  const fetchMasterUser = async (ID) => {
    setLoading(true);
    try {
      const response = await ApiService.getPublic(
        `api/CenPilot/FormerMasterList?userId=${ID}`
      );

      console.log("data for Master User", response);

      if (response === "Invalid Device ID.") {
        alert("Invalid Device ID. Please log in again.");
        localStorage.clear();
        history.push("/login");
        return;
      }

      const responseData = response;

      if (Array.isArray(responseData) && responseData.length > 0) {
        const fullData = responseData.flatMap((item) =>
          Array.isArray(item.MasterDetails) ? item.MasterDetails : []
        );

        console.log("fullData", fullData);

        setUserMasters(fullData);
        setError("");
      } else {
        setUserMasters([]);
        alertify.warning("No data found for the provided user ID.");
      }
    } catch (err) {
      console.error("Error fetching User Master:", err);

      if (
        err?.response?.data === "Invalid Device ID." ||
        err?.message?.includes("Invalid Device ID")
      ) {
        alert("Invalid Device ID. Please log in again.");
        localStorage.clear();
        history.push("/login");
        return;
      }

      setError("Failed to fetch User Master");
      alertify.error("Failed to fetch User Master...");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // console.log = function() {};

    const user = Number(localStorage.getItem("user_id"));
    if (user) {
      console.log("user", user);
      fetchUser(user);
    }
  }, [EditModal]);

  const topRight = (message) => {
    alertify.set("notifier", "position", "top-right");
    alertify.message(message);
  };

  const columns = [
    {
      title: "#",
      dataIndex: "ID",
      key: "ID",
      sorter: (a, b) => Number(a.ID) - Number(b.ID),
    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
      render: (text, record) => (
        <h2 className="table-avatar">
          <div to="/profile">{record.Name}</div>
        </h2>
      ),
      sorter: (a, b) => a.Name.localeCompare(b.Name),
    },
    {
      title: "Mobile",
      dataIndex: "Phone",
      key: "Phone",
      sorter: (a, b) => a.Phone.localeCompare(b.Phone),
    },
    {
      title: "Location",
      dataIndex: "GeoLocation",
      key: "GeoLocation",
      render: (text, record) => {
        const mapsLink = `https://www.google.com/maps?q=${record.GeoLocation}`; // Corrected template literal
        return (
          <div>
            <a href={mapsLink} target="_blank" rel="noopener noreferrer">
              Location
            </a>
          </div>
        );
      },
    },
    {
      title: "City",
      dataIndex: "City",
      key: "City",
      sorter: (a, b) => a.City.localeCompare(b.City),
    },
    {
      title: "Email",
      dataIndex: "Email",
      key: "Email",
      sorter: (a, b) => a.Email.localeCompare(b.Email),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <div className="d-flex align-items-center">
          <div className="dropdown dropdown-action">
            <button
              className="btn-action-icon border-0"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fas fa-ellipsis-v"></i>
            </button>
            <div className="dropdown-menu dropdown-menu-right">
              <ul>
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      setUserList(record);
                      setHideContent(!hideContent);
                      setModalShow(!modalShow);
                      // fetchMaster(record.ID);
                      fetchMasterUser(record.ID);
                      setUserIdReload(record.ID);
                    }}
                  >
                    <i className="far fa-eye me-2"></i>View
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      setEditTemple(record);
                      setHideContent(!hideContent);
                      setEditModal(true);
                    }}
                  >
                    <i className="far fa-edit me-2"></i>Edit
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ),
    },
  ];

  // Handler when page changes
  const onPageChange = (page) => {
    setCurrentPage(page);
  };

  const onShowSizeChange = (current, size) => {
    setPageSize(size);
  };

  const filteredUserList = user.filter((u) => {
    const searchLower = (searchQuery || "").toLowerCase();

    return [
      u.Name,
      u.Phone,
      u.Email,
      u.State,
      u.City,
      u.Address,
      u.DeviceID,
      u.GeoLocation,
      u.Creater,
      u.DateTime,
      u.Status, // number
      u.ID, // number
      u.created_by, // number
    ]
      .filter(Boolean)
      .some((field) =>
        String(field)
          .toLowerCase()
          .includes(searchLower)
      );
  });

  // Paginate filtered temples
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedTemples = filteredUserList.slice(startIndex, endIndex);

  /**
   * Exports the filtered user data to a CSV file
   */
  const exportToCSV = () => {
    if (!user || user.length === 0) {
      alert("No data to export");
      return;
    }

    const flattenedData = user.map((user) => {
      return {
        Id: user.ID,
        Name: user.Name,
        Phone: user.Phone,
        State: user.State,
        City: user.City,
        Address: user.Address,
        Email: user.Email,
        Status: user.Status === 1 ? "Active" : "Inactive",
      };
    });

    console.log("flattenedData", flattenedData);

    // Prepare CSV headers
    const headers = Object.keys(flattenedData[0]).join(",");

    // Prepare rows
    const rows = flattenedData.map((row) =>
      Object.values(row)
        .map((value) => `"${value}"`)
        .join(",")
    );

    // Combine headers and rows
    const csvContent = [headers, ...rows].join("\n");

    // Create a blob for the CSV
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    // Trigger the download
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All_User_Data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  // master add

  // Filtered master list based on search input
  const filteredMasters = search
    ? FetchMaster.filter((m) =>
        m.Name.toLowerCase().includes(search.toLowerCase())
      )
    : [];

  // Handle master selection
  const handleSelect = (master) => {
    setSelectedMasters((prevSelected) => {
      const isAlreadySelected = prevSelected.some(
        (m) => m.MasterId === master.MasterId
      );

      if (isAlreadySelected) {
        // Remove if already selected (toggle selection)
        return prevSelected.filter((m) => m.MasterId !== master.MasterId);
      } else {
        // Add if not selected
        return [...prevSelected, master];
      }
    });

    setSearch(""); // Clear search after selection
  };

  // Handle save button click
  const handleSave = async () => {
    if (selectedMasters.length > 0) {
      try {
        console.log("Selected Masters:", selectedMasters);

        const FUlldata = selectedMasters.map((master) => ({
          UserID: Number(UserList.ID),
          MasterId: master.MasterId,
        }));

        const response = await AddMasterServer(FUlldata);
        console.log("Server Response:", response);

        document.getElementById("closeModal").click();
        setSelectedMasters([]);
        fetchMaster(UserIdReload); // Refresh master list
        fetchMasterUser(UserIdReload); // Refresh master list
        console.log("master list reload, master list");
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        {hideContent && (
          <div className="page-wrapper">
            <div className="content container-fluid">
              {/* Page Header */}
              <div className="page-header">
                <div className="content-page-header">
                  <h5>Users Details</h5>
                  <div className="list-btn">
                    <ul className="filter-list">
                      <li>
                        <input
                          type="text"
                          name="search_temple"
                          placeholder="Search..."
                          className="form-control"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </li>
                      <div className="link-search d-flex justify-content-between">
                        <li>
                          <Link to="/useregister">
                            <div className="btn btn-primary">
                              <i
                                className="fa fa-plus-circle me-2"
                                aria-hidden="true"
                              />
                              Register
                            </div>
                          </Link>
                        </li>
                        <li>
                          <a className="btn btn-primary" onClick={exportToCSV}>
                            <i
                              className="fa fa-download me-2"
                              aria-hidden="true"
                            />
                            Export
                          </a>
                        </li>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}

              {/* Table */}
              <div className="row">
                <div className="col-sm-12">
                  <div className="card-table">
                    <div className="card-body purchase">
                      <div className="table-responsive table-hover">
                        {loading && (
                          <div
                            className="spinner-border text-success loading-main"
                            role="status"
                          />
                        )}
                        {error && <p className="error-main">{error}</p>}

                        {!loading && !error && (
                          <Table
                            pagination={{
                              total: user.length,
                              current: currentPage,
                              pageSize: pageSize,
                              showSizeChanger: true,
                              onChange: onPageChange,
                              onShowSizeChange: onShowSizeChange,
                            }}
                            columns={columns}
                            dataSource={paginatedTemples.map((item, index) => ({
                              ...item,
                              key: index,
                            }))}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Table */}
            </div>
          </div>
        )}

        {/* <!-- Modal 1 --> */}
        {modalShow && (
          <>
            <div className="page-wrapper">
              <div className="content container-fluid">
                <div className="row justify-content-lg-center">
                  <div className="col-lg-10">
                    {/* Page Header */}
                    <div className="page-header">
                      <div className="content-page-header d-flex justify-content-start">
                        <button
                          type="button"
                          className="btn btn-link me-1"
                          onClick={() => {
                            setHideContent(true);
                            setModalShow(false);
                          }}
                        >
                          Back
                        </button>
                        <h5>Profile</h5>
                      </div>
                    </div>

                    {/* /Page Header */}
                    {UserList && (
                      <>
                        <div className="profile-cover">
                          <div className="profile-cover-wrap">
                            <img
                              className="profile-cover-img"
                              src={`https://www.themodelskit.co.uk/wp-content/uploads/2021/01/shutterstock_376903072-731x1024.jpg`}
                              alt="Profile Cover"
                              id="cover-image"
                            />
                          </div>
                        </div>
                        <div className="text-center mb-5">
                          <label
                            className="avatar avatar-xxl profile-cover-avatar"
                            htmlFor="avatar_upload"
                          >
                            <img
                              className="avatar-img"
                              src={`https://www.themodelskit.co.uk/wp-content/uploads/2021/01/shutterstock_376903072-731x1024.jpg`}
                              alt="Profile Image"
                              id="blah"
                            />
                          </label>
                          <h2>{UserList.Name}</h2>
                          <ul className="list-inline">
                            {UserList.Email && (
                              <li className="list-inline-item">
                                <i className="fa-solid fa-envelope"></i>
                                <span className="ms-2">{UserList.Email}</span>
                              </li>
                            )}
                            {UserList.Phone && (
                              <li className="list-inline-item">
                                <i className="fa-solid fa-phone"></i>
                                <span className="ms-2">{UserList.Phone}</span>
                              </li>
                            )}
                          </ul>
                        </div>
                        <div className="row justify-content-start align-items-start">
                          {/* Profile Section */}
                          <div className="col-lg-6 align-self-center">
                            <div className="card">
                              <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className="card-title d-flex justify-content-between align-items-center">
                                  <span>Profile</span>
                                </h5>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-link"
                                  data-bs-toggle="modal"
                                  data-bs-target="#exampleModal"
                                  data-bs-whatever="@mdo"
                                  onClick={() => {
                                    fetchMaster();
                                  }}
                                >
                                  Link Master
                                </button>
                              </div>

                              <div className="card-body">
                                <ul className="list-unstyled mb-0 d-flex flex-column gap-1">
                                  {/* About Section */}
                                  <li className="py-0">
                                    <h6>About</h6>
                                  </li>
                                  <li>{UserList?.Name || "N/A"}</li>

                                  {/* Contacts Section */}
                                  <li className="pt-2 pb-0">
                                    <h6>Contacts</h6>
                                  </li>
                                  {UserList?.Phone ? (
                                    <li>{UserList.Phone}</li>
                                  ) : (
                                    <li>N/A</li>
                                  )}

                                  {/* Address Section */}
                                  <li className="pt-2 pb-0">
                                    <h6>Address</h6>
                                  </li>
                                  <li>
                                    {UserList?.Address ? (
                                      <>
                                        {UserList.Address},<br />
                                        {UserList.City},<br />
                                        {UserList.State}
                                      </>
                                    ) : (
                                      "N/A"
                                    )}
                                  </li>

                                  {/* Location Section */}
                                  <li className="pt-2 pb-0">
                                    <h6>Location</h6>
                                  </li>
                                  <li>
                                    {UserList?.Location ? (
                                      <a
                                        href={`https://www.google.com/maps?q=${UserList.Location}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <i className="fa-solid fa-map"></i> Map
                                      </a>
                                    ) : (
                                      "N/A"
                                    )}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          {loading && (
                            <div className="col-lg-6 align-self-center text-center">
                              <div
                                className="spinner-border text-success m-2 loading-master-data"
                                role="status"
                              />
                            </div>
                          )}

                          {/* User Masters Table */}
                          {!loading && (
                            <div className="col-lg-6 table-responsive align-self-start">
                              {Array.isArray(UserMasters) &&
                              UserMasters.length > 0 ? (
                                <Table
                                  pagination={{
                                    total: UserMasters.length,
                                    current: currentPage,
                                    pageSize: pageSize,
                                    showSizeChanger: true,
                                    onChange: (page) => setCurrentPage(page),
                                    onShowSizeChange: (current, size) =>
                                      setPageSize(size),
                                  }}
                                  loading={loading}
                                  columns={[
                                    {
                                      title: "ID",
                                      dataIndex: "ID",
                                      key: "ID",
                                    },
                                    {
                                      title: "MasterId",
                                      dataIndex: "MasterId",
                                      key: "MasterId",
                                    },
                                    {
                                      title: "Name",
                                      dataIndex: "Name",
                                      key: "Name",
                                    },
                                    {
                                      title: "City",
                                      dataIndex: "City",
                                      key: "City",
                                    },
                                    {
                                      title: "Village",
                                      dataIndex: "Village",
                                      key: "Village",
                                    },
                                    {
                                      title: "Location",
                                      dataIndex: "Location",
                                      key: "Location",
                                      render: (text) => {
                                        if (!text) return "N/A";
                                        const coordinates = text.split(",");
                                        const latitude = coordinates[0]?.trim();
                                        const longitude = coordinates[1]?.trim();

                                        return latitude && longitude ? (
                                          <a
                                            href={`https://www.google.com/maps?q=${latitude},${longitude}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-primary"
                                          >
                                            View Location
                                          </a>
                                        ) : (
                                          "N/A"
                                        );
                                      },
                                    },
                                  ]}
                                  dataSource={UserMasters.map(
                                    (item, index) => ({
                                      ...item,
                                      key: item.Id || index, // Ensure a unique key
                                    })
                                  )}
                                />
                              ) : (
                                !loading && (
                                  <p className="text-center align-items-center mt-5">
                                    No User Master data available...
                                  </p>
                                )
                              )}
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* Modal 2 */}
        {EditModal && (
          <UserDetailEdit
            editUser={editTemple}
            setEditModal={setEditModal}
            setEditUser={setEditTemple}
            setHideContent={setHideContent}
          />
        )}
      </div>

      {/* <!-- Modal --> */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Select Master</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              {/* Search Input */}
              <input
                type="text"
                className="form-control mb-2"
                placeholder="Search Master..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />

              {Masterloading && (
                <div className="col-lg-12 align-self-center text-center mt-2">
                  <div
                    className="spinner-border text-success m-4 loading-master-data"
                    role="status"
                  />
                </div>
              )}

              {/* Search Results */}
              {filteredMasters.length > 0 && (
                <ul className="list-group">
                  {filteredMasters.map((master) => (
                    <li
                      key={master.MasterId}
                      className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center ${
                        selectedMasters.some(
                          (m) => m.MasterId === master.MasterId
                        )
                          ? "active text-white"
                          : ""
                      }`}
                      onClick={() => handleSelect(master)}
                      style={{ cursor: "pointer" }}
                    >
                      {master.Name}
                      <input
                        type="checkbox"
                        checked={selectedMasters.some(
                          (m) => m.MasterId === master.MasterId
                        )}
                        readOnly
                      />
                    </li>
                  ))}
                </ul>
              )}

              {/* Display Selected Masters */}
              {selectedMasters.length > 0 && (
                <div className="card mt-3">
                  <div className="card-body">
                    <h5 className="card-title">Selected Masters</h5>
                    <ul>
                      {selectedMasters.map((master) => (
                        <li key={master.MasterId}>
                          {master.Name} - 📍 {master.City}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>

            <div className="modal-footer d-flex gap-3">
              <button
                id="closeModal"
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSave}
                disabled={selectedMasters.length === 0}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllMasterDetails;
